<template>
  <div class="container">
    <v-row justify="space-between">
      <v-col>
        <v-skeleton-loader :loading="loading" type="list-item" max-width="200">
          <h3 class="mb-4 mt-3">Artikel</h3>
        </v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row v-if="loading">
      <v-col cols="12" md="3" v-for="(item, i) in 8" :key="i">
        <v-skeleton-loader type="card"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" md="3" v-for="(item, i) in loadData" :key="i">
        <ArticleCard
          :title="item.title"
          :date="item.created_at"
          :publisher="item.user_id"
          :poster="item.attachment"
          :route="{
            name: 'ArticleDetail',
            params: { slug: item.slug, id: item.id },
          }"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ArticleCard from '../components/ArticleCard';
import Axios from 'axios';
export default {
  name: 'Article',
  components: {
    ArticleCard,
  },
  data() {
    return {
      loading: true,
      loadData: [],
    };
  },
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'articles')
      .then(response => {
        this.loadData = response.data.data;
      })
      .catch(error => {
        console.log(error);
        this.error = true;
        this.errorMessage = error;
      })
      .finally(() => (this.loading = false));
  },
  metaInfo() {
    return {
      title: 'Semua artikel event kampus',
      titleTemplate: '%s - Eventversity',
      htmlAttrs: {
        lang: 'id',
        amp: true,
      },
    };
  },
};
</script>

<style scoped></style>
